import { Sender } from 'xstate';

import asyncCallback from '../../../framework/logic/utils/asyncCallback';
import { LogicContext } from '../types';

import config from '../../../config';
import { getGroupedCodesFromJPTiles } from '../../../utils/jackpotsV2/getGroupedCodesFromJPTiles';
import { getJackpotsForJPTiles } from '../../../utils/jackpotsV2/getJackpotsForJPTiles';

export const watchJackpots = (context: LogicContext) =>
  asyncCallback(
    async (
      callback: Sender<{
        type: 'JACKPOTS_UPDATED';
        data: {
          multiJackpots: { [key: string]: any };
        };
      }>
    ) => {
      let intervalId: ReturnType<typeof setInterval>;

      const { controllersData } = context;
      if (!controllersData.categories) {
        return () => {};
      }
      const { components } = controllersData.categories;
      const jackpotTileGroupedCodes = getGroupedCodesFromJPTiles(components);

      if (jackpotTileGroupedCodes && config.intervals.jackpotsCheck) {
        intervalId = setInterval(async () => {
          const currency = context.user?.currency || config.default_currency;
          const multiJackpots = jackpotTileGroupedCodes.length
            ? await getJackpotsForJPTiles(jackpotTileGroupedCodes, currency)
            : {};

          callback({
            type: 'JACKPOTS_UPDATED',
            data: {
              multiJackpots: multiJackpots,
            },
          });
        }, config.intervals.jackpotsCheck);
      }

      return () => {
        if (intervalId) {
          clearInterval(intervalId);
        }
      };
    }
  );
